import React from "react";
import logo from "../../assets/logobgc.png";
import "./loading.css"

export default function Loading() {
  return (
    <div>
      <img className="logoimg" src={logo} alt="SIGER" />
      <div className="d-flex justify-content-center">
        <div className="spinner-border text-warning" role="status"></div>
      </div>
    </div>
  );
}
